import { Component, OnInit, Input } from "@angular/core";
import { SharedService } from "../../../services/shared.service";

@Component({
  selector: "app-msline-chart",
  templateUrl: "./msline-chart.component.html",
  styleUrls: ["./msline-chart.component.scss"]
})
export class MsLineChartComponent implements OnInit {
  public dataSource: Object;
  public chart: any;
  public chartType: string;
  public duration = [
    {
      id: "1m",
      name: "1M",
      active: 0,
      duration: 1,
      attr: "one_month_previous_price_return",
      returns: "-"
    },
    {
      id: "3m",
      name: "3M",
      active: 0,
      duration: 3,
      attr: "three_month_previous_price_return",
      returns: "-"
    },
    {
      id: "6m",
      name: "6M",
      active: 0,
      duration: 6,
      attr: "six_month_previous_price_return",
      returns: "-"
    },
    {
      id: "1y",
      name: "1Y",
      active: 0,
      duration: 12,
      attr: "last_year_price_return",
      returns: "-"
    },
    {
      id: "3Y",
      name: "3Y",
      active: 0,
      duration: 36,
      attr: "three_year_previous_price_return",
      returns: "-"
    },
    {
      id: "5Y",
      name: "5Y",
      active: 0,
      duration: 60,
      attr: "five_year_previous_price_return",
      returns: "-"
    },
    {
      id: "10Y",
      name: "10Y",
      active: 1,
      duration: 120,
      attr: "ten_year_previous_price_return",
      returns: "-"
    }
  ];
  public selDur = 6;
  public startInd = 0;
  public orgLabels = [];
  public orgDataSets = [];
  public returns: any;

  @Input() chartData = { type: "msline" };
  @Input() type = 0;
  @Input() showDuration = true;

  constructor(public _shared: SharedService) {
    this.dataSource = {
      chart: {
        theme: "fusion",
        caption: "",
        drawAnchors: 0,
        anchorRadius: 1,
        anchorBorderThickness: 1,
        decimals: 0,
        showLabels: 0
      },
      categories: [{ category: [] }],
      dataset: []
    };
  }

  ngOnInit() {}

  initialized($event) {
    this.chart = $event.chart;
    this.updateChart(this.chartData);
    console.log("Ms line");
  }

  // Safari-safe date parser
  parseDateSafe(dateStr) {
    if (!dateStr) return new Date(NaN);

    var str = (dateStr + "").trim();

    // "Jan 2020" or "January 2020"
    var monthNameYear = str.match(/^([A-Za-z]+)\s+(\d{4})$/);
    if (monthNameYear) {
      var months = {
        jan: "01",
        feb: "02",
        mar: "03",
        apr: "04",
        may: "05",
        jun: "06",
        jul: "07",
        aug: "08",
        sep: "09",
        oct: "10",
        nov: "11",
        dec: "12"
      };
      var m = months[monthNameYear[1].toLowerCase().slice(0, 3)];
      if (m) return new Date(monthNameYear[2] + "-" + m + "-01");
      return new Date(NaN);
    }

    // "2020-01" — missing day, Safari fails this
    var yearMonth = str.match(/^(\d{4})-(\d{2})$/);
    if (yearMonth) {
      return new Date(yearMonth[1] + "-" + yearMonth[2] + "-01");
    }

    // "YYYY-MM-DD" — fully safe for Safari, check BEFORE MM-DD-YYYY
    var ymdDash = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymdDash) {
      return new Date(ymdDash[1] + "-" + ymdDash[2] + "-" + ymdDash[3]);
    }

    // NEW: "MM-DD-YYYY" e.g. "07-25-2019"
    var mdyDash = str.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (mdyDash) {
      return new Date(mdyDash[3] + "-" + mdyDash[1] + "-" + mdyDash[2]);
    }

    // "MM/DD/YYYY"
    var mdySlash = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (mdySlash) {
      return new Date(mdySlash[3] + "-" + mdySlash[1] + "-" + mdySlash[2]);
    }

    // "YYYY/MM/DD"
    var ymdSlash = str.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (ymdSlash) {
      return new Date(ymdSlash[1] + "-" + ymdSlash[2] + "-" + ymdSlash[3]);
    }

    // "YYYY-MM-DD HH:mm:ss" — Safari needs T separator not space
    var isoSpace = str.match(/^(\d{4}-\d{2}-\d{2})\s(\d{2}:\d{2}:\d{2})/);
    if (isoSpace) {
      return new Date(isoSpace[1] + "T" + isoSpace[2]);
    }

    // Fallback
    return new Date(str);
  }
  updateChart(data) {
    if (!this.chart) return;

    if (data && data.genConfig) {
      var config = Object.keys(data.genConfig);
      config.forEach(
        function(val) {
          try {
            this.dataSource["chart"][val] = data.genConfig[val];
          } catch (error) {
            console.log("updateChart error:", error);
          }
        }.bind(this)
      );
    }

    // Guard: ensure datasets and labels are valid arrays
    var datasets =
      data && data.config && Array.isArray(data.config.dataSets)
        ? data.config.dataSets
        : [];
    var labels =
      data && data.config && Array.isArray(data.config.labels)
        ? data.config.labels
        : [];

    this.dataSource["dataset"] = datasets;
    this.dataSource["categories"][0]["category"] = labels;
    this.orgLabels = labels;
    this.orgDataSets = datasets;

    // Guard: only calculate returns if datasets and data exist
    if (
      datasets.length > 0 &&
      datasets[0].data &&
      datasets[0].data.length > 0
    ) {
      var datalen = datasets[0].data.length;
      var firstVal = parseFloat(datasets[0].data[0].value);
      var lastVal = parseFloat(datasets[0].data[datalen - 1].value);

      if (!isNaN(firstVal) && !isNaN(lastVal)) {
        var returns = lastVal - firstVal;
        this.duration[this.selDur].returns = "" + returns + "";
        this.returns = returns;
      }
    }

    if (this.showDuration) {
      this.getDurationData(this.selDur);
    } else {
      this.chart.setJSONData(this.dataSource);
    }
  }

  getDurationData(ind) {
    // Guard: valid index
    if (ind < 0 || ind >= this.duration.length) return;

    this.duration[this.selDur].active = 0;
    this.duration[ind].active = 1;
    this.selDur = ind;
    this.startInd = 0;

    var curDate = new Date();
    var durDate = this.minusMonths(
      new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate()),
      this.duration[ind].duration
    );
    this.getDataForDuration(curDate, durDate);
  }

  getDataForDuration(curDate, durDate) {
    // Guard: nothing to render
    if (
      !this.orgLabels ||
      !this.orgLabels.length ||
      !this.orgDataSets ||
      !this.orgDataSets.length
    ) {
      this.drawGraph([], []);
      return;
    }

    try {
      var dataSets = this.orgDataSets.map(function(ds) {
        return {
          seriesname: ds.seriesname,
          color: ds.color,
          data: []
        };
      });

      var dataLabels = [];

      this.orgLabels.forEach(
        function(val, key) {
          // Safari-safe date parse
          var ddate = this.parseDateSafe(val.label);

          // Guard: skip invalid dates
          if (isNaN(ddate.getTime())) return;

          if (ddate >= durDate) {
            if (this.startInd === 0) {
              this.startInd = key;
            }
            dataLabels.push({ label: val.label });

            this.orgDataSets.forEach(
              function(v, k) {
                // Guard: ensure dataSets[k] exists
                if (dataSets[k]) {
                  dataSets[k].data.push(this.orgDataSets[k].data[key]);
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );

      // Only normalize if we have data points
      dataSets.forEach(
        function(val, key) {
          if (dataSets[key].data.length > 0) {
            dataSets[key].data = this.getDataInRatio(
              dataSets[key].data,
              "value"
            );
          }
        }.bind(this)
      );

      this.drawGraph(dataLabels, dataSets);
    } catch (error) {
      console.log("getDataForDuration error:", error);
    }
  }

  getDataInRatio(orgData, field) {
    // Guard: empty array
    if (!orgData || orgData.length === 0) return [];

    // Guard: find first valid non-zero base value
    var firstValid = orgData.find(function(v) {
      return (
        v != null &&
        v[field] != null &&
        parseFloat(v[field]) !== 0 &&
        !isNaN(parseFloat(v[field]))
      );
    });

    // If no valid base found, return zeros instead of NaN
    if (!firstValid) {
      return orgData.map(function() {
        return { value: "0" };
      });
    }

    var baseValue = parseFloat(firstValid[field]);

    return orgData.map(function(val, key) {
      // Guard: handle undefined / null / non-numeric values
      if (val == null || val[field] == null || isNaN(parseFloat(val[field]))) {
        return { value: "0" };
      }

      if (key === 0) {
        return { value: "100" };
      }

      var dd = (100 * parseFloat(val[field])) / baseValue;

      // Guard: final NaN / Infinity check
      if (!isFinite(dd) || isNaN(dd)) {
        return { value: "0" };
      }

      return { value: dd.toFixed(2) };
    });
  }

  minusMonths(dt, n) {
    return new Date(dt.setMonth(dt.getMonth() - n));
  }

  drawGraph(dataLabels, dataSets) {
    // Guard: only calculate returns if dataSets has data
    if (
      dataSets.length > 0 &&
      dataSets[0].data &&
      dataSets[0].data.length > 0
    ) {
      var datalen = dataSets[0].data.length;
      var firstVal = parseFloat(dataSets[0].data[0].value);
      var lastVal = parseFloat(dataSets[0].data[datalen - 1].value);

      if (!isNaN(firstVal) && !isNaN(lastVal)) {
        var returns = lastVal - firstVal;
        this.duration[this.selDur].returns = "" + returns + "";
        this.returns = returns;
      }
    }

    this.dataSource["dataset"] = dataSets;
    this.dataSource["categories"][0]["category"] = dataLabels;
    this.chart.setJSONData(this.dataSource);
  }
}
